<template>
    <v-layout column fill-height style="display: flex;flex-flow: column;align-items: stretch;">
        <v-container class="no-padding overflow-y" style="flex: 1 1 auto;margin-bottom: 175px !important;">

            <v-list three-line>
                <template v-for="(item, index) in messages">
                    <v-subheader
                            v-if="item.header"
                            :key="item.header"
                    >
                        {{ item.header }}
                    </v-subheader>

                    <v-divider
                            v-else-if="item.divider"
                            :key="index"
                    ></v-divider>

                    <v-list-tile
                            v-else
                            :key="item.key"
                            avatar
                            class="no-clickable"
                            v-bind:class="{'bg-mine': item.mine}"
                    >

                        <v-list-tile-avatar  v-if="!item.mine">
                            <img :src="item.avatar">
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title v-if="!item.mine" v-html="item.title"></v-list-tile-title>
                            <v-list-tile-sub-title>
                                <span class='text--primary'>{{item.text}}</span>
                                <br>
                                <span class='text--secondary'>{{$moment(item.date).fromNow()}}</span>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-avatar  v-if="item.mine">
                            <img :src="item.avatar">
                        </v-list-tile-avatar>

                    </v-list-tile>

                </template>
            </v-list>

        </v-container>

        <v-footer color="" light class="elevation-1" style="padding-bottom: 0px;width:100%; position: absolute;bottom: 0;height: auto">
            <v-container style="padding-bottom: 0;">
                <v-layout row fill-height>
                    <v-textarea v-model="input"
                                :label="$t('Message')"
                                required flat outline
                    ></v-textarea>

                    <v-btn fab color="primary" @click="sendMessage" :loading="sending" :disabled="sending || !canSendMessages">
                        <v-icon>send</v-icon>
                    </v-btn>

                </v-layout>
            </v-container>
        </v-footer>
    </v-layout>

</template>

<script>

    import FilesRepository from '../repositories/FilesRepository';
    import AuthRepository from '../repositories/AuthRepository';
    import { VList, VFooter, VTextarea, VSubheader, VDivider, VListTile, VListTileAvatar, VListTileContent, VToolbar, VListTileTitle, VListTileSubTitle, VLayout, VToolbarTitle, VBtn, VIcon, VForm, VTextField, VContainer, VAlert } from 'vuetify/lib'

    export default {
        name: 'Comments',
        components: {
            VList, VSubheader, VDivider, VListTile, VListTileAvatar, VListTileContent, VListTileTitle, VListTileSubTitle,
            VLayout, VBtn, VIcon, VContainer, VFooter, VTextarea
        },
        props: {
            hash: String,
            token: String,
        },
        watch: {
            hash: function () {
                this.loadMessages();
            },
            $user: function () {
                this.loadMessages();
            },
        },
        data () {
            return {
                // Comments loading
                loading: false,
                // Send button loading
                sending: false,
                // Input message
                input: "",
                // Messages list
                messages: [],
                // Decide if the user can send messages
                canSendMessages: false,
                // The current user id
                userId: null,
            }
        },
        created () {
            this.loadMessages();
            if (this.token) {
                AuthRepository.getMe(this.token).then(this.onGetMe);
            }
            if (this.$user) {
                this.canSendMessages = true;
                this.userId = this.$user._id;
            }
        },
        methods: {
            onGetMe(user) {
                if (user) {
                    this.userId = user._id;
                    this.$socket.emit('LOGIN', {id: user._id});
                    this.canSendMessages = true;
                }
            },
            loadMessages() {
                if (this.hash && (this.$user || this.token)) {
                    this.loading = true;
                    this.messages = [];
                    FilesRepository.getComments(this.hash, this.token)
                        .then((response) => {
                            if (response.data.comments) {
                                // Parse comments
                                for (let comment of response.data.comments) {
                                    comment.hash = this.hash;
                                    this.addMessageToArray(comment);
                                }
                            }
                            this.loading = false;
                        })
                        .catch((error) => {
                        });
                }
            },

            sendMessage() {
                if (this.canSendMessages) {
                    this.sending = true;
                    this.$socket.emit('SEND_MESSAGE', {
                        hash: this.hash,
                        text: this.input
                    });
                    this.input = "";
                }
            },

            addMessageToArray(comment) {
                if (comment.hash === this.hash) {
                    this.messages.push({
                           key: this.messages.length,
                           avatar: comment.creator.avatar,
                           title: comment.creator.name,
                           date: comment.date,
                           text: comment.text,
                           mine: comment.creator.id === this.userId,
                    });
                    this.messages.push({divider: true});
                }
            },
        },

        sockets: {

            MESSAGE(params) {
                let data = params[0];
                this.addMessageToArray(data);
                this.sending = false;
            }

        }
    }
</script>

<style lang="scss">
    .bg-mine {
        //-webkit-animation:rainbow .5s infinite;
        //-ms-animation:rainbow .5s infinite;
        //-o-animation:rainbow .5s infinite;
        //animation:rainbow .5s infinite;
        background: #efefef;
    }

    @-webkit-keyframes rainbow {
        0% {background: #ff0000;}
        10% {background: #ff8000;}
        20% {background: #ffff00;}
        30% {background: #80ff00;}
        40% {background: #00ff00;}
        50% {background: #00ff80;}
        60% {background: #00ffff;}
        70% {background: #0080ff;}
        80% {background: #0000ff;}
        90% {background: #8000ff;}
        100% {background: #ff0080;}
    }
    @-ms-keyframes rainbow {
        0% {background: #ff0000;}
        10% {background: #ff8000;}
        20% {background: #ffff00;}
        30% {background: #80ff00;}
        40% {background: #00ff00;}
        50% {background: #00ff80;}
        60% {background: #00ffff;}
        70% {background: #0080ff;}
        80% {background: #0000ff;}
        90% {background: #8000ff;}
        100% {background: #ff0080;}
    }
    @-o-keyframes rainbow {
        0% {background: #ff0000;}
        10% {background: #ff8000;}
        20% {background: #ffff00;}
        30% {background: #80ff00;}
        40% {background: #00ff00;}
        50% {background: #00ff80;}
        60% {background: #00ffff;}
        70% {background: #0080ff;}
        80% {background: #0000ff;}
        90% {background: #8000ff;}
        100% {background: #ff0080;}
    }
    @keyframes rainbow {
        0% {background: #ff0000;}
        10% {background: #ff8000;}
        20% {background: #ffff00;}
        30% {background: #80ff00;}
        40% {background: #00ff00;}
        50% {background: #00ff80;}
        60% {background: #00ffff;}
        70% {background: #0080ff;}
        80% {background: #0000ff;}
        90% {background: #8000ff;}
        100% {background: #ff0080;}
    }
</style>